// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/tv-minimal.js';

import { paths } from '../generated/tv-minimal';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('tv-minimal', Original, paths);
